import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {Flex as $ec3baf921918e057$export$f51f4c4ede09e011} from "../layout/Flex.mjs";
import {HelpText as $ef3f0b17611eb293$export$a67c0bc59081311a} from "./HelpText.mjs";
import {Label as $f6f5235bab1fa21e$export$b04be29aa201d4f5} from "./Label.mjs";
import "../fieldlabel_vars.css";
import $b5RF6$fieldlabel_vars_cssmjs from "../fieldlabel_vars_css.mjs";
import {SlotProvider as $62024859ff9f1f8a$export$8107b24b91795686} from "../utils/Slots.mjs";
import {useFormProps as $c29c48d4ef19ffc4$export$a6b5be5c6b451665} from "../form/Form.mjs";
import {useStyleProps as $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41} from "../utils/styleProps.mjs";
import {mergeProps as $b5RF6$mergeProps} from "react-aria/mergeProps";
import $b5RF6$react from "react";
import {useId as $b5RF6$useId} from "react-aria/useId";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 










const $adcd096854d27620$export$a455218a85c89869 = /*#__PURE__*/ (0, $b5RF6$react).forwardRef(function Field(props, ref) {
    let formProps = (0, $c29c48d4ef19ffc4$export$a6b5be5c6b451665)(props);
    let isInForm = formProps !== props;
    props = formProps;
    let { label: label, labelPosition: labelPosition = 'top', labelAlign: labelAlign, isRequired: isRequired, necessityIndicator: necessityIndicator, includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName, validationState: validationState, isInvalid: isInvalid, description: description, errorMessage: errorMessage = (e)=>e.validationErrors.join(' '), validationErrors: validationErrors, validationDetails: validationDetails, isDisabled: isDisabled, showErrorIcon: showErrorIcon, contextualHelp: contextualHelp, children: children, labelProps: labelProps = {}, descriptionProps: // Not every component that uses <Field> supports help text.
    descriptionProps = {}, errorMessageProps: errorMessageProps = {}, elementType: elementType, wrapperClassName: wrapperClassName, wrapperProps: wrapperProps = {}, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $63d03c54ca5e4b88$export$b8e6fb9d2dff3f41)(otherProps);
    let errorMessageString = null;
    if (typeof errorMessage === 'function') errorMessageString = isInvalid != null && validationErrors != null && validationDetails != null ? errorMessage({
        isInvalid: isInvalid,
        validationErrors: validationErrors,
        validationDetails: validationDetails
    }) : null;
    else errorMessageString = errorMessage;
    let hasHelpText = !!description || errorMessageString && (isInvalid || validationState === 'invalid');
    let contextualHelpId = (0, $b5RF6$useId)();
    let fallbackLabelPropsId = (0, $b5RF6$useId)();
    if (label && contextualHelp && !labelProps.id) labelProps.id = fallbackLabelPropsId;
    let labelWrapperClass = (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))), 'spectrum-Field', {
        'spectrum-Field--positionTop': labelPosition === 'top',
        'spectrum-Field--positionSide': labelPosition === 'side',
        'spectrum-Field--alignEnd': labelAlign === 'end',
        'spectrum-Field--hasContextualHelp': !!props.contextualHelp
    }, styleProps.className, wrapperClassName);
    children = /*#__PURE__*/ (0, $b5RF6$react).cloneElement(children, (0, $b5RF6$mergeProps)(children.props, {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))), 'spectrum-Field-field')
    }));
    let renderHelpText = ()=>/*#__PURE__*/ (0, $b5RF6$react).createElement((0, $ef3f0b17611eb293$export$a67c0bc59081311a), {
            descriptionProps: descriptionProps,
            errorMessageProps: errorMessageProps,
            description: description,
            errorMessage: errorMessageString,
            validationState: validationState,
            isInvalid: isInvalid,
            isDisabled: isDisabled,
            showErrorIcon: showErrorIcon,
            gridArea: (0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))).helpText
        });
    let renderChildren = ()=>{
        if (labelPosition === 'side') return /*#__PURE__*/ (0, $b5RF6$react).createElement((0, $ec3baf921918e057$export$f51f4c4ede09e011), {
            direction: "column",
            UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))), 'spectrum-Field-wrapper')
        }, children, hasHelpText && renderHelpText());
        return /*#__PURE__*/ (0, $b5RF6$react).createElement((0, $b5RF6$react).Fragment, null, children, hasHelpText && renderHelpText());
    };
    let labelAndContextualHelp = /*#__PURE__*/ (0, $b5RF6$react).createElement((0, $b5RF6$react).Fragment, null, label && /*#__PURE__*/ (0, $b5RF6$react).createElement((0, $f6f5235bab1fa21e$export$b04be29aa201d4f5), {
        ...labelProps,
        labelPosition: labelPosition,
        labelAlign: labelAlign,
        isRequired: isRequired,
        necessityIndicator: necessityIndicator,
        includeNecessityIndicatorInAccessibilityName: includeNecessityIndicatorInAccessibilityName,
        elementType: elementType
    }, label), label && contextualHelp && /*#__PURE__*/ (0, $b5RF6$react).createElement((0, $62024859ff9f1f8a$export$8107b24b91795686), {
        slots: {
            actionButton: {
                UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))), 'spectrum-Field-contextualHelp'),
                id: contextualHelpId,
                'aria-labelledby': labelProps?.id ? `${labelProps.id} ${contextualHelpId}` : undefined
            }
        }
    }, contextualHelp));
    // Need to add an extra wrapper for the label and contextual help if labelPosition is side,
    // so that the table layout works inside forms.
    if (isInForm && labelPosition === 'side' && label && contextualHelp) labelAndContextualHelp = /*#__PURE__*/ (0, $b5RF6$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))), 'spectrum-Field-labelCell')
    }, /*#__PURE__*/ (0, $b5RF6$react).createElement("div", {
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($b5RF6$fieldlabel_vars_cssmjs))), 'spectrum-Field-labelWrapper')
    }, labelAndContextualHelp));
    return /*#__PURE__*/ (0, $b5RF6$react).createElement("div", {
        ...styleProps,
        ...wrapperProps,
        ref: ref,
        className: labelWrapperClass
    }, labelAndContextualHelp, renderChildren());
});


export {$adcd096854d27620$export$a455218a85c89869 as Field};
//# sourceMappingURL=Field.mjs.map
